const apiCodes = {
  FIRST_LOGIN: '00015',
  PASSWORD_EXPIRED: '00607',
  MFA_EMAIL_VERIFICATION: '00606',
  MFA_CODE_VERIFICATION: '00600',
  MFA_USER_BLOCK: ''
}

export default apiCodes
